module.exports = __webpack_public_path__ + "img/logo-9.70649a10.png";